import React, { useState, useEffect } from 'react';
import Close from '../../assets/icons/Close'
import styles from './ModalWrapper.module.css'


const ModalWrapper = ({ mwShow=true, mwHandleOnClose=null, mwClickOutsideToClose=false, mwComponentToRender:MwComponentToRender, mwComponentToRenderProps={}, ...props }) => {
    const [_show, _setShow] = useState(mwShow)
    const [_mwComponentToRenderProps, _setMwComponentToRenderProps] = useState(mwComponentToRenderProps)

    useEffect(() => {
        _setShow(mwShow)
        _setMwComponentToRenderProps(mwComponentToRenderProps)
    }, [mwShow, mwComponentToRenderProps])


    const _onClose = (event) => {
        event.stopPropagation()
        _setShow(false)
        mwHandleOnClose && mwHandleOnClose()
        //mwHandleOnClose()
    }

    return (
        <>
        {_show &&
        <div className={styles.modalwrapper_overlay} onClick={(e) => (mwClickOutsideToClose && _onClose(e))}>
            <div className={styles.modalwrapper_content} onClick={(e) => e.stopPropagation()}>
                <div>
                    <button
                        className={styles.modalwrapper_button_close}
                        onClick={(e) => _onClose(e)}
                        title="Fechar"
                        style={{ float: 'right' }}>
                            <Close width='25px' height='25px' onClick={(e) =>_onClose(e)} />
                    </button>
                </div>
                <MwComponentToRender style={{zIndex: 102}} {..._mwComponentToRenderProps} />
            </div>
        </div>
        }
        </>
    )
}

export default ModalWrapper
